import $ from 'jquery'
import {UserExceptionType} from "./constants"
import TemplateView from "../../TemplateView";
import CustomCheckbox from "../../components/customCheckbox/CustomCheckbox";
import CustomRadio from '../../components/customCheckbox/CustomRadio';
import messageResource from "../../messageResource";
import { Product } from '../../constants';
import MinimumValueInput from './components/MinimumValueInput';
import IconWithTooltip from '../../IconWithTooltip';
import UsersFilter from '../darSettings/components/UsersFilter';

export class LowBalanceSettingsContainer extends TemplateView {
    constructor({
        setEnabled,
        setMinimalValue,
        setUserExceptionType,
        setExceptionUsers,
        product,
        isProductsIntegrated,
    }) {
        super()

        this.state = {
            enabled: false,
            minimalValue: false,
            units: null,
            defaultWorkDayDuration: undefined,
            userExceptionType: UserExceptionType.NoException,
            exceptionUsers: {
                all: false,
                userIds: [],
                groupIds: [],
                groupType: null,
            },

            ugrEnabled: false,
            tzgEnabled: false,
            ttaEnabled: false,
            wsdEnabled: false,
            userGroups: [],
            timeZoneGroups: [],
            users: [],
        }

        this.props = {
            product,
            isProductsIntegrated,
        }

        this.actions = {
            setEnabled,
            setMinimalValue,
            setUserExceptionType,
            setExceptionUsers
        }

        this.onStatePropertyChanged('enabled', (value) => {
            this.enabledCheckbox.setState({ checked: value })
            this.minimumValueInput.setState({ disabled: !value })
            this.radioContainer.toggleClass('visible', value);
        })

        this.onStateChanged(() => {
            const newState = {
                userIds: this.state.exceptionUsers.userIds,
                groupIds: this.state.exceptionUsers.groupIds,
                all: this.state.exceptionUsers.all,
                groupType: this.state.exceptionUsers.groupType,
                users: this.state.users,
                userGroups: this.state.userGroups,
                timeZoneGroups: this.state.timeZoneGroups,
                ugrEnabled: this.state.ugrEnabled,
                tzgEnabled: this.state.tzgEnabled,
            }

            this.usersSelector.setState(newState)
        })

        this.onStatePropertyChanged('userExceptionType', (value) => {
            this.usersSelector.setState({
                disabled: value !== UserExceptionType.SelectedUsers,
            })
        })

        this.onStatePropertyChanged('minimalValue', (value) => this.minimumValueInput.setState({ value }))
        this.onStatePropertyChanged('units', (units) => this.minimumValueInput.setState({ units }))
    }

    templateHtml() {
        return  `<div class="lowBalance_container">
                    <div class="lowBalance_checkbox"></div>
                    <div class="lowBalance_controls">
                        <div class="lowBalance_controls__item NoException"><div class="label"></div></div>
                        <div class="lowBalance_controls__item Managers"><div class="label"></div></div>
                        <div class="lowBalance_controls__item SelectedUsers">
                            <div class="label"></div>
                            <div class="userSelector"></div>
                            <div class="note"></div>
                        </div>
                    </div>
                </div>`
    }

    afterRender() {
        super.afterRender();

        const $enableCheckbox = this.$el.find('.lowBalance_checkbox')
        this.radioContainer = this.$el.find('.lowBalance_controls')

        this.enabledCheckbox = new CustomCheckbox({
            htmlLabel: messageResource.getMessage('general_settings.balance.low.enable'),
            onChange: ({checked}) => this.actions.setEnabled(checked),
            checkboxAdditionalClass: 'checkboxInput',
            checkmarkAdditionalClass: 'hiddenCheckmark',
        }).init($enableCheckbox)

        this.minimumValueInput = new MinimumValueInput({
            additionalClass: 'settingsInput',
            value: this.state.minimalValue,
            maxLength: 6,
            onChange: this.actions.setMinimalValue,
        }).init($enableCheckbox)

        this.checkboxes = Object.values(UserExceptionType).map(type => {
            const checkbox = this.$el.find('.lowBalance_controls__item.' + type + ' .label')
            return new CustomRadio({
                label: messageResource.getMessage('general_settings.balance.low.' + type),
                onChange: () => this.setUserExceptionType(type),
                checked: this.state.userExceptionType === type,
                containerAdditionalClass: type,
            }).init(checkbox)
        })

        let featureEnabled = false

        if (this.props.product === Product.actiTIME) {
            featureEnabled = this.state.ttaEnabled
        } else {
            featureEnabled = this.state.wsdEnabled
        }

        const tooptip = featureEnabled
            ? 'general_settings.balance.low.note.managers'
            : 'general_settings.balance.low.note.managers_feature_disabled'

        tooptip && new IconWithTooltip(
            messageResource.getMessage(tooptip),
            'lowBalanceNoteTooltip'
        ).init(this.radioContainer.find('.lowBalance_controls__item.' + UserExceptionType.Managers))

        const selectedUsersSelector = '.lowBalance_controls__item.' + UserExceptionType.SelectedUsers

        this.usersSelector = new UsersFilter({
            selectionCallback: this.actions.setExceptionUsers,
        }).init(this.radioContainer.find(selectedUsersSelector + ' .userSelector'))

        new IconWithTooltip(
            messageResource.getMessage('general_settings.balance.low.note.selected_users'),
            'lowBalanceNoteTooltip'
        ).init(this.radioContainer.find(selectedUsersSelector + ' .note'))
    }

    setUserExceptionType(type) {
        this.actions.setUserExceptionType(type)
        this.checkboxes.forEach((checkbox) =>
        checkbox.setState({ checked: checkbox.getEl()[0].classList.contains(type) }))
    }

    setUnits(units) {
        this.setState({ units })
    }

    setWorkdayDuration(defaultWorkDayDuration) {
        this.setState({ defaultWorkDayDuration: defaultWorkDayDuration / 60 })
        this.minimumValueInput.setState({ defaultWorkDayDuration: defaultWorkDayDuration / 60 })
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/lowBalanceSettings/LowBalanceSettingsContainer.js